export default __webpack_public_path__ + "static/media/student-engagement.4809263a.png";